module.exports = __webpack_public_path__ + "static/Verne2-87866333ff210d49ca90ff4f2ab5f1b8.png";